/**
 * PRODUCT PAGE LOGIC
 * Handles the Sticky Add to Cart Bar visibility and Gallery image swapping.
 * Handles Shopify Cart AJAX API interactions for Adding to Cart.
 */

class ProductPage {
  constructor() {
    this.initStickyCart();
    this.initGallery();
    this.initAjaxCart();
  }

  initStickyCart() {
    const mainAddToCart = document.getElementById('MainAddToCartBtn');
    const stickyBar = document.getElementById('StickyActionBar');

    if (!mainAddToCart || !stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.y < 0) {
          stickyBar.classList.add('is-active');
        } else {
          stickyBar.classList.remove('is-active');
        }
      });
    }, observerOptions);

    stickyObserver.observe(mainAddToCart);
  }

  initGallery() {
    const thumbnails = document.querySelectorAll('.product-gallery__thumb');
    const mainImage = document.getElementById('MainProductImage');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        mainImage.src = e.target.src.replace('width=100', 'width=1000'); 
        thumbnails.forEach(t => t.setAttribute('aria-current', 'false'));
        e.target.setAttribute('aria-current', 'true');
      });
    });
  }

  initAjaxCart() {
    // Handle the main product form
    const form = document.querySelector('.product-add-form');
    if (form) {
      form.addEventListener('submit', (e) => {
        const idInput = form.querySelector('[name="id"]');
        if (idInput && (idInput.value === '1' || idInput.value === '')) {
          e.preventDefault();
          alert('Theme Editor Preview: Cannot add dummy product to cart. Please select a real product first!');
          return;
        }

        e.preventDefault();
        const formData = new FormData(form);
        this.addToCartAjax(formData, false, e.submitter || form.querySelector('button[type="submit"]'));
      });
    }

    // Handle quick-add buttons on the featured collection grid
    const quickAddBtns = document.querySelectorAll('.js-ajax-add');
    quickAddBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); // Stop bubbling to anchor tag
        e.stopPropagation();

        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId || variantId === '1') {
          alert('Theme Editor Preview: Assign a real product to test the cart.');
          return;
        }

        let formData = {
          'items': [{
            'id': parseInt(variantId),
            'quantity': 1
          }]
        };

        this.addToCartAjax(JSON.stringify(formData), true, btn);
      });
    });
  }

  addToCartAjax(data, isJSON = false, btn = null) {
    const originalText = btn ? btn.innerText : 'Add to Cart';
    if (btn) btn.innerText = 'Adding...';

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    const endpoint = rootUrl.endsWith('/') ? rootUrl + 'cart/add.js' : rootUrl + '/cart/add.js';

    // Safely encode FormData to URL format for Shopify
    const bodyData = isJSON ? data : new URLSearchParams(data);

    const fetchHeaders = isJSON ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/x-www-form-urlencoded' };
    // CRITICAL: Tells Shopify not to redirect to the cart page HTML!
    fetchHeaders['X-Requested-With'] = 'XMLHttpRequest';
    fetchHeaders['Accept'] = 'application/json';

    fetch(endpoint, {
      method: 'POST',
      headers: fetchHeaders,
      body: bodyData
    })
    .then(async response => {
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Failed to add to cart (Server rejected request)');
      }
      return response.json();
    })
    .then(item => {
      if (btn) btn.innerText = originalText;
      this.showCartToast('Added to cart!');
    })
    .catch((error) => {
      console.error('Error:', error);
      if (btn) btn.innerText = originalText;
      // Show exactly what the server complained about
      alert('Error: ' + error.message);
    });
  }

  showCartToast(message) {
    const toast = document.getElementById('CartToast');
    if (!toast) return;

    toast.classList.add('is-active');
    
    // Auto-hide after 3 seconds
    setTimeout(() => {
      toast.classList.remove('is-active');
    }, 3000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductPage();
});
